import React, { Component } from 'react'
import without from 'lodash/without'
import { isMobile } from '../../utils'

export default class InlineMultiselect extends Component {
  constructor(props) {
    super(props)
    this.multiselectRef = React.createRef()
    this.state = {
      selectedItems: [],
    }

    this.setSelectedImtes()
  }

  componentDidUpdate(prevProps) {
    if(JSON.stringify(prevProps.variants) !== JSON.stringify(this.props.variants)) {
      this.setSelectedImtes()
    }
  }

  componentDidMount() {
    let isActive = false
    let ev = isMobile() ? 'touchend' : 'click'
    let $elem = this.multiselectRef.current
    let clickingCallback = function(el, p) {
      $elem.classList.add('open')
      isActive = true
    }
    $elem.addEventListener(ev, clickingCallback)
    document.addEventListener(ev, function(e) {
      if(!$elem.contains(e.target) && isActive) {
        $elem.classList.remove('open')
        isActive = false
      }
    })
  }

  setSelectedImtes() {
    let selectedItems = []

    this.props.variants.forEach(item => {
      if(item.checked) {
        selectedItems.push(item.id)
      }
    })

    this.setState({
      selectedItems,
    })
  }

  changeEvent = (variant, value) => {
    let items = [...this.state.selectedItems]
    let id = variant.id

    if(value) {
      items.push(id)
      variant.checked = true
    } else {
      items = without(items, id)
      variant.checked = false
    }

    this.setState({
      selectedItems: items,
    }, () => {
      if(typeof this.props.onSelect === 'function') {
        this.props.onSelect(this.state.selectedItems)
      }
    })
  }

  render() {
    const { title, variants } = this.props
    const { selectedItems } = this.state

    return (
      <div className='multi-select white' ref={this.multiselectRef}>
        <span className='dropdown-toggle'>{ title }&nbsp;
          { selectedItems.length ? (
            <i>({ selectedItems.length })</i>
          ) : '' }
        </span>
        <ul aria-labelledby='dropdownMenu' className='ititnerary-filter dropdown-menu'>
          {
            variants.map((variant) => {
              return (<li key={variant.id}>
                <a >
                  <label className='checkbox-wrap'>
                    <input type='checkbox' checked={variant.checked} onChange={(e) => this.changeEvent(variant, e.target.checked)} />
                    <span />
                    <p>{variant.title}</p>
                  </label>
                </a>
              </li>)
            })
          }
        </ul>
      </div>
    )
  }
}
